<template lang="pug">
  .modal.is-active
    .modal-background(@click="cerrarModal")
    .modal-content
      .box
        h5.title {{ config.title }}
        p {{ config.content }}
        br
        .columns
          .column
            .level-right
              .field.is-grouped
                p.control
                  a.button.is-rounded(@click="cerrarModal")
                    | {{ config.textCancel }}
                p.control
                  a.button.is-black.is-rounded(@click="aceptar")
                    | {{ config.textOk }}
</template>

<script>
  export default {
    name: 'ModalYN',
    props: {
      config: {
        type: Object,
        default: () => {}
      }
    },
    methods: {
      cerrarModal () {
        this.$emit('padre:close', false)
      },
      aceptar () {
        this.$emit('padre:close', true)
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/shared/ModalYN.vue